import { makeStyles } from "tss-react/mui";
import colors from "assets/theme/base/colors";

export const useStyles = makeStyles()((theme) => ({
  modalWrapper: {
    position: "fixed",
    left: 0,
    right: 0,
    top: 80,
    bottom: 0,
    zIndex: 2,
    background: colors.background.primary,
    backdropFilter: "contrast(0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  modalContent: {
    maxWidth: 320,
    width: theme.width.ninetyVw,
    background: theme.palette.white.main,
    padding: `${theme.spacing.spacing20} ${theme.spacing.spacing16} ${theme.spacing.spacing16}`,
    borderRadius: 30,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  modalTitle: {
    fontSize: theme.typography.size.sm,
    fontWeight: theme.typography.fontWeightBold,
    margin: `${theme.spacing.spacing8} 0 ${theme.spacing.spacing4}`,
    textAlign: "center",
  },
  modalDescription: {
    fontSize: theme.typography.size.sm,
    fontWeight: theme.typography.fontWeightRegular,
    textAlign: "center",
  },
  loader: {
    position: "relative",
  },
  actions: {
    marginTop: theme.spacing.spacing8,
  },
  btn: {
    height: theme.spacing.spacing28,
    width: theme.width.width75,
  }
}));

